import { Component, Inject } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';

@Component({
  selector: 'app-onboarding-bottom-sheet',
  templateUrl: './onboarding-bottom-sheet.component.html',
  styleUrl: './onboarding-bottom-sheet.component.scss',
})
export class OnboardingBottomSheetComponent {
  constructor(@Inject(MAT_BOTTOM_SHEET_DATA) public data: { content: string }) {}
}
